import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export interface HeaderBreadcrumb {
  label: string;
  path?: string;
  isPill?: boolean;
  pillColor?: string;
  icon?: ReactNode;
}

export interface HeaderState {
  backUrl?: string;
  backLabel?: string;
  breadcrumbs?: HeaderBreadcrumb[];
  customTitle?: string;
}

interface HeaderContextType {
  headerState: HeaderState | null;
  setHeaderState: (state: HeaderState | null) => void;
  clearHeaderState: () => void;
}

export const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

export function HeaderProvider({ children }: { children: ReactNode }) {
  const [headerState, setHeaderState] = useState<HeaderState | null>(null);

  const clearHeaderState = () => setHeaderState(null);

  return (
    <HeaderContext.Provider value={{ headerState, setHeaderState, clearHeaderState }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeaderBreadcrumbs(state: HeaderState | null | undefined) {
  const context = useContext(HeaderContext);
  const stateKey = state ? JSON.stringify(state) : '';

  useEffect(() => {
    if (context && state) {
      context.setHeaderState(state);
    }
    return () => {
      if (context) {
        context.clearHeaderState();
      }
    };
  }, [stateKey]);
}

export function useHeader() {
  const context = useContext(HeaderContext);
  return context;
}
